import { render } from "./AddIbutton.vue?vue&type=template&id=4cd6f887"
import script from "./AddIbutton.vue?vue&type=script&lang=js"
export * from "./AddIbutton.vue?vue&type=script&lang=js"
script.render = render

export default script